<template>
  <Loader v-if="loading" />
  <card v-else
    page="login"
    style="overflow:visible;"
  >
    <label class="top-label">TERMS AND CONDITIONS</label>
    <form-component>
      <form
        id="terms-and-conditions"
        data-vv-scope="terms-and-conditions"
        novalidate="novalidate"
        @submit.prevent="save"
      >
        <div class="col-12 terms-checkbox">
          <input
            id="of_age"
            v-model="of_age"
            v-validate="'required'"
            name="of_age"
            type="checkbox"
          >
          <label class="form-check-label" for="of_age">
            I acknowledge that I am at least 18 years of age.
          </label>
        </div>
        <div class="col-12 terms-checkbox">
          <input
            id="terms"
            v-model="terms"
            v-validate="'required'"
            name="terms"
            type="checkbox"
          >
          <label class="form-check-label" for="terms">
            I have read and I accept BetterMynd's
            <a
              :href="`/docs/student_terms.pdf`"
              target="_blank"
              class="green"
            >
              Terms &amp; Conditions
            </a>
          </label>
        </div>
        <div
          v-if="showCampusDataUseTerms"
          class="col-12 terms-checkbox"
        >
          <input
            id="campus_consent"
            v-model="campus_consent"
            v-validate="'required'"
            name="campus_consent"
            type="checkbox"
          >
          <label class="form-check-label" for="campus_consent">
            I acknowledge that BetterMynd may share information 
            about my use of the platform and de-identified demographic 
            information with my campus.
          </label>
        </div>

        <div class="row mt-3">
          <div class="col-12 col-md-6 order-md-2">
            <button
              class="btn btn--primary"
              type="submit"
            >
              <span class="text-center">Continue</span>
              <span class="float-right">
                <font-awesome-icon :icon="['fas', 'arrow-right']" size="lg" />
              </span>
            </button>
          </div>
          <div class="col-12 col-md-6 order-md-1" />
        </div>
      </form>
    </form-component>
  </card>
</template>

<script>
import FormComponent from '@/components/FormComponent.vue';
import Card from '@/components/Card.vue';
import Loader from '@/components/Loader.vue';

export default {
  components: {
    FormComponent,
    Card,
    Loader
  },
  computed: {
    showCampusDataUseTerms() {
      return this.school && !this.isFaculty
    },
  },
  data() {
    return {
      terms: false,
      of_age: false,
      campus_consent: false,

      school: null,
      loading: false,
      isFaculty: false,
    }
  },
  async mounted(){
    try{
      this.loading = true;
      this.school = this.$store.getters.currentUser.school;
      
      if(this.school) {
        this.isFaculty = await this.$globals.schoolHasFeature(
          'users-are-faculty', 
          this.school.id);
      }
    } catch(ex) {
      console.error(ex);
    } finally { 
      this.loading = false;
    }
  },
  methods:{
    async save() {
      const result = await this.$validator.validateAll('terms-and-conditions');
      if (!result) {
        this.$store.commit('setGlobalAlert', {
          msg: 'You must agree to all terms and conditions to use the BetterMynd application',
        });
        return;
      }

      this.$emit('complete', null);
    }
  },
}
</script>

<style lang="scss" scoped>

.terms-checkbox {
  display:flex;
  margin-bottom:5px;
}
input[type=checkbox] {
  position: absolute;
  left: 20px;
  top: 5px;
  width: 20px;
  height: 20px;
}
input[type=checkbox] + label {
  display: inline-block;
  position: relative;
  padding-left: 25px;
  font-size: 16px;
  line-height: 20px;
  margin: 5px;
}
input[type=checkbox] + label:before {
  line-height: 20px;
  content: "";
  display: inline-block;
  width: 20px;
  height: 20px;
  position: absolute;
  left: 0;
  background-color: $blue;
  border: 1px solid $off-blue;
}
input[type=checkbox]:checked + label:before {
  content: "\2713";
  color: $green;
  text-align: center;
  line-height: 20px;
  font-weight: bold;
  cursor: pointer;
}
input[type=checkbox] + label:hover {
  cursor: pointer;
}
input[type=checkbox] + label:active:before {
  content: "\26F6";
  color: $off-blue;
  text-align: center;
  line-height: 16px;
}
</style>
